import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { Metamodel } from 'app/model/base/model';
import { SapHanaDataset } from 'app/model/dataset/saphana.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapHanaDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SapHanaDatasetAdapter extends TabularTypeDatasetAdapter<SapHanaDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SapHanaDataset): Promise<Model.DatasetResource> {
        return this._toResourceInternal(dataset, Metamodel.modelFor(SapHanaDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SapHanaDataset): Promise<SapHanaDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SapHanaDataset.MODEL);
    }
}
